<!--
custom sort-link that doesnt change size when unsorted and uses text not link color
https://github.com/BernhardtD/vue-sorted-table
-->


<!-- I left this here inheriting from vue-sorted-table incase we need to customize it later -->
<script>
import { SortedTable } from "vue-sorted-table";

export default {
  name: "sorted-table",
  mixins: [SortedTable],
};
</script>
